module.exports = __webpack_public_path__ + "static/dorian_martin-c0fb98d052c4a91fa6a9eb86e0b15ac7.jpg";